import { render, staticRenderFns } from "./dashboardHr.vue?vue&type=template&id=64b3a71e"
import script from "./dashboardHr.vue?vue&type=script&lang=js"
export * from "./dashboardHr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports